import React, { FC, Suspense } from 'react'
import cn from 'clsx'
import Trans from 'next-translate/Trans'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Category } from '@lib/api'
import { Footer, Navbar } from '@components/common'
import { useDynamicOpacityClass } from '@lib/hooks/useOpacityClasses'
import { HeaderOpacityClasses } from '@components/common/Layout/HeaderOpacityClasses'
import { SidebarUI } from '@components/common/Layout/SidebarUi'
import { Banner } from '@components/ui/Banner/Banner'
import { sendEvent } from '@lib/tracking'

interface Props {
  pageProps: {
    menuCategories?: Category[]
    sizeGuideURL?: string
  }
}

const Layout: FC<Props> = ({ children, pageProps: { ...pageProps } }) => {
  const { opacityClass } = useDynamicOpacityClass('bg-dark', 0)
  const { pathname } = useRouter()
  const isHome = pathname === '/'

  return (
    <div className="h-full relative gradient-background">
      <div className="relative z-20 text-base">
        <HeaderOpacityClasses />
        {isHome && process.env.NEXT_PUBLIC_IS_VALENTINES_ACTIVE === 'true' ? (
          <Banner eventText={'common:banner_text'} href={'/gifts/all'}>
            <Trans
              i18nKey={'common:banner_text'}
              components={[<span className="underline" key={0} />]}
            />
          </Banner>
        ) : null}

        <div className={cn('sticky w-full h-20 top-0 z-20', opacityClass)}>
          <div className="top-0 z-20 max-w-content-xl mx-content-margin-mobile sm:mx-content-margin-desktop 2xl:mx-auto">
            <Navbar />
          </div>
        </div>
        <main className="min-h-screen relative z-10 mt-8">{children}</main>
        <div className="max-w-content-xl mx-content-margin-mobile sm:mx-content-margin-desktop 2xl:mx-auto">
          <SidebarUI
            menuCategories={pageProps.menuCategories ?? []}
            sizeGuideURL={pageProps.sizeGuideURL}
          />
        </div>
        <Suspense fallback={<></>}>
          <Footer />
        </Suspense>
      </div>
    </div>
  )
}

export default Layout
